import EditTemplateRestricted from 'components/Shared/Permission/EditTemplateRestricted'
import { CampaignManagement, TemplatedCampaignManagement } from 'components/Shared/Permission/enums'
import { useNewTranslation } from 'hooks'
import { useCheckSomePermissions, usePermission } from 'hooks/permissions'
import Toggle from 'particles/Toggle'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectCampaignByTemplateData } from 'state'
import { CAMPAIGN_STATUS_ENUM } from 'state/campaigns'

interface ExportToggleProps {
    isExport: boolean
    setIsExport: React.Dispatch<React.SetStateAction<boolean>>
}

const ExportToggle = ({ isExport, setIsExport }: ExportToggleProps) => {
    const [t] = useNewTranslation()
    const isInternalPermission = usePermission(TemplatedCampaignManagement.CreateAndEditBriefsForInternal)
    const campaign = useSelector(selectCampaignByTemplateData)
    const ableToExport = useCheckSomePermissions([
        CampaignManagement.CreateAndEditBriefsForExternal,
        CampaignManagement.CreateAndEditBriefsForInternal,
    ])
    if (
        campaign?.status === CAMPAIGN_STATUS_ENUM.LIVE ||
        campaign?.status === CAMPAIGN_STATUS_ENUM.CLOSED ||
        !ableToExport
    ) {
        return null
    }

    if (campaign?.status === CAMPAIGN_STATUS_ENUM.FOR_REVIEW && isInternalPermission) {
        return (
            <Toggle
                label={t('campaign.template.step3.paymentConfirmation.customiseToggle.title')}
                subtext={t('campaign.template.step3.paymentConfirmation.customiseToggle.subText')}
                isChecked={isExport}
                handleChange={() => {
                    setIsExport(prev => !prev)
                }}
                isReadOnly
            />
        )
    }

    return (
        <EditTemplateRestricted>
            <Toggle
                label={t('campaign.template.step3.paymentConfirmation.customiseToggle.title')}
                subtext={t('campaign.template.step3.paymentConfirmation.customiseToggle.subText')}
                isChecked={isExport}
                handleChange={() => {
                    setIsExport(prev => !prev)
                }}
            />
        </EditTemplateRestricted>
    )
}
export default ExportToggle
